
import { customSelect } from "../modules/customSelect";

export function requestInfoForm() {

    MktoForms2.whenReady(function (form) {
        // customSelect();
        $("#FirstName").closest(".mktoFormRow").addClass("half-width");
        $("#LastName").closest(".mktoFormRow").addClass("half-width");

        const select = $(form.getFormElem()[0]).find("select");

        $("body").on("change", "select", function (){
            if ($(this).val()) {
                return $(this).css("color", "#5C5C5C");
            } else {
                return $(this).css("color", "#9E9E9E");
            }
        });

        form.onSuccess(function(values, followUpUrl) {
            const scrollPosition = $(".request-info-form").offset().top - $(".header").outerHeight();
            $("body, html").animate({scrollTop: scrollPosition});
        });

    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/requestInfoForm.js